import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=547601d5&scoped=true"
import script from "./login-form.vue?vue&type=script&lang=ts"
export * from "./login-form.vue?vue&type=script&lang=ts"
import style0 from "./login-form.vue?vue&type=style&index=0&id=547601d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547601d5",
  null
  
)

export default component.exports